<template>
  <van-list
    class="pro_con"
    v-model="Loading"
    :finished="Finished"
    finished-text="没有更多了"
    @load="loadMore"
  >
    <div class="pro_con_wrap">
      <div class="pro_con_item"  v-for="(item, index) in List" :key="'pro-con-' + index"  @click="LinkProduct(item.productId)" >
        <div class="img_div">
          <img :src="item.banner[0]" v-if="item.banner[0]" v-load="'oMyPro'"/>
          <img src="@assets/img/empty.png" v-else />
        </div>
        <p class="pro_title">{{item.name}}</p>
        <div class="con_info">
          <img :src="item.logo" v-if="item.logo"  v-load="'oLogoSmall'"/>
          <img src="@assets/img/empty.png" v-else />
          <p  @click.stop="LinkExhibitionDetails(item.exhibitorId)" >{{item.compName}}</p>
        </div>
      </div>
    </div>
  </van-list>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "collect-product",
  data() {
    return {
      Loading: false, //产品动态加载状态
      Finished: false, //产品加载是否完成状态
      List: [], //产品列表
      pageSize: 12,
      pageIndex: 0,
      totalCount: 0,
      totalPages: 0
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userId: "getUserId"
    }),
    option() {
      return {
        exhibitionId: this.exhibitionId,
        userId: this.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
    }
  },
  created() {},
  methods: {
    ...mapActions({
      getProductFollower: "follower/getProductLove",
      LinkProduct:'linkTo/LinkProduct',
      LinkExhibitionDetails:'linkTo/LinkExhibitionDetails',
    }),
    async init() {
      this.Loading = true;
      // setTimeout(() => {
      //   this.Loading = false;
      // }, 5000);
      const req = {};
      const list = await this.getProductFollower(this.option);
      if (list.code && !list.result) {
        this.Loading = false;
        this.Finished = true;
        return;
      }
      if(list.items && list.items.length){
        list.items.map(c => {
          if (c.banner.indexOf("[") === 0) {
            c.banner = JSON.parse(c.banner);
          } else {
            c.banner = [];
          }
        });
        this.List.push(...list.items);
      }
      this.pageSize = list.pageSize;
      this.pageIndex = list.pageIndex;
      this.totalCount = list.totalCount;
      this.totalPages = list.totalPages;
      this.Loading = false;
      if (this.totalCount >= this.List.length) {
        this.Finished = true;
      }
    },
    loadMore() {
      if (this.Finished) return;
      this.pageIndex += 1;
      this.init();
    },
    //tab切换
    tabActive(){
      this.List=[];
      this.pageIndex=1;
      this.Finished=false;
      this.Loading =true;
      this.init();
    },
  }
};
</script>

<style scoped lang="scss">
//产品内容
.pro_con {
  padding: 0 0.24rem 0;
  .pro_con_wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &::after {
      content: "";
      width: 30%;
      border: 1px solid transparent;
    }
    .pro_con_item {
      // width: 2.25rem;
      width: 32.1%;
      border-radius: 3px;
      overflow: hidden;
      background: #1d2435;
      margin-bottom: 0.15rem;
      color: #fff;
      .img_div{
        position: relative;
        width: 100%;
        height: 0px;
        padding-top: 100%;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
      }
      
      .pro_title {
        line-height: 1;
        padding: 0.15rem 0.1rem 0.09rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .con_info {
        padding: 0 0.05rem 0.1rem 0.1rem;
        display: flex;
        img {
          width: 0.24rem;
          height: 0.24rem;
          border-radius: 50%;
          display: block;
          margin-right: 0.04rem;
          transform: translateY(0.03rem);
        }
        p {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
